import React, { forwardRef, useCallback, useState } from "react";
import { Select } from "../Shell/index.js";
import useSearchType from "./useSearchType.js";
const SearchTypeSelectWithRef = forwardRef(function SearchTypeSelect(props, ref) {
    const { searchTypeExtendedOptions, onSearchTypeChange, searchType } = useSearchType();
    const [isFocus, setIsFocus] = useState(false);
    const onFocus = useCallback(() => {
        setIsFocus(true);
    }, []);
    const onBlur = useCallback(() => {
        setIsFocus(false);
    }, []);
    return (React.createElement(Select, { isFocus: isFocus, onFocus: onFocus, onBlur: onBlur, onChange: ({ currentTarget }) => {
            onSearchTypeChange(currentTarget.value);
        }, value: searchType, options: searchTypeExtendedOptions, ref: ref }));
});
export default SearchTypeSelectWithRef;
